import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/terpstra/terpstra-style.scss';
import SvgIcon from '../../modules/svg-icon';
import AddressLookup from '../../modules/geolocate';
import * as Incrementer from '../../modules/incrementer';
import LightGallery from '../../modules/lightgallery';
import Recaptcha from '../../modules/recaptcha';
import FilterTags from '../../modules/filter-tags';
import RealTimePrice from '../../modules/realtime-price';

document.addEventListener('DOMContentLoaded', () => {
  const svgIcon = new SvgIcon();
  const addressLookup = new AddressLookup({});
  const recaptcha = new Recaptcha({
    key: '6Leqkv8cAAAAACdVu2-Se-QGCMZq46orfZavBIW4'
  });
  const lightGallery = new LightGallery();
  const filterTags = new FilterTags();
  const realtimePrice = new RealTimePrice();
  svgIcon.init();
  addressLookup.init();
  lightGallery.init();
  Incrementer.default({});
  recaptcha.init();
  filterTags.init();
  realtimePrice.init();
});
